import React from 'react';

interface CategoryNavigationProps {
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const categories = ["All", "Competitive Programming", "Scratch Coding Game", "EcoQuest Web App", "Innovative Technology Challenge"];

const CategoryNavigation: React.FC<CategoryNavigationProps> = ({
  selectedCategory,
  onSelectCategory
}) => {
  return (
    <div className="mb-5 text-center">
      <ul className="flex flex-wrap justify-center gap-2">
        {categories.map((category) => (
          <li
            key={category}
            className={`border hover:border-defaultBlue rounded-full  p-1 px-5 font-semibold hover:text-defaultBlue transition-colors cursor-pointer bg-white  ${(selectedCategory === category ||
                (category === 'All' && selectedCategory === null))
                ? 'text-defaultBlue border-defaultBlue'
                : 'text-gray-400 border-gray-400'
              }`}
            onClick={() => onSelectCategory(category === 'All' ? null : category)}
          >
            {category}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryNavigation;